import CryptoJS from 'crypto-js';

// Utility function to convert base64 to WordArray
function base64ToWordArray(base64) {
    const parsedWordArray = CryptoJS.enc.Base64.parse(base64);
    return parsedWordArray;
}

// Utility function to convert hex string to WordArray
function hexToWordArray(hex) {
    const parsedWordArray = CryptoJS.enc.Hex.parse(hex);
    return parsedWordArray;
}

// Function to decrypt data using AES-256-CBC
async function decryptData(encryptedData) {
    const secretKey = process.env.REACT_APP_ENCRYPTION_SECRET;
    const ivString = process.env.REACT_APP_ENCRYPTION_IV;

    if (!secretKey || !ivString) {
        throw new Error('Encryption secret or IV not found in environment variables');
    }

    try {
        // 1. Remove any surrounding quotes
        const cleanIV = (ivString || '')?.replace(/^"|"$/g, '');

        // 2. Handle Base64 URL-safe encoding if needed
        const formattedData = encryptedData?.replace(/-/g, '+')?.replace(/_/g, '/');

        // 3. Parse as hex
        const key = CryptoJS.enc.Hex.parse(secretKey);
        const iv = CryptoJS.enc.Hex.parse(cleanIV);

        // 4. Decrypt
        const decrypted = CryptoJS.AES.decrypt(formattedData, key, { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });

        // 5. Validate result
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        if (!decryptedText) throw new Error('Empty result - wrong key/IV');

        return JSON.parse(decryptedText);
    } catch (error) {
        console.error('Decryption Failed:', {
            key: secretKey?.slice(0, 6) + '...',
            iv: ivString?.slice(0, 6) + '...',
            error: error.message
        });
        throw error;
    }
}

export default decryptData;
